'use strict';

var _objectSpread = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
module.exports = function (url, options) {
  if (typeof url !== 'string') {
    throw new TypeError("Expected `url` to be of type `string`, got `".concat(typeof url, "`"));
  }
  url = url.trim();
  options = _objectSpread({
    https: true
  }, options);
  if (/^\.*\/|^(?!localhost)\w+:/.test(url)) {
    return url;
  }
  return url.replace(/^(?!(?:\w+:)?\/\/)/, options.https ? 'https://' : 'http://');
};